export const c_menu_m_flyout__menu_left_offset = {
  "name": "--pf-v6-c-menu--m-flyout__menu--left-offset",
  "value": "0px",
  "var": "var(--pf-v6-c-menu--m-flyout__menu--left-offset)"
};
export default c_menu_m_flyout__menu_left_offset;